import { render } from "./MedicalPlan.vue?vue&type=template&id=cf0d06a6"
import script from "./MedicalPlan.vue?vue&type=script&lang=js"
export * from "./MedicalPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__